export const SAVE_PROPOSAL_MODAL_TEST_ID = 'save-proposal-modal';
